/**
 * Asynchronously loads the component for StudentNotifications
 */

import { lazyLoad } from "utils/loadable";

export const StudentNotifications = lazyLoad(
  () => import("./index"),
  (module) => module.StudentNotifications
);
